<ngx-json-ld *ngIf="schema" [json]="schema"></ngx-json-ld>
<ng-container *ngIf="layout">
    <div>
        <app-block-grid (loadedBlock)="buildLayout()" [isMainLayout]="true" [agent]="agent" [item]="layout" [blocksRef]="blocks" [id]="layout._id" [grid]="layout.grid" [span]="layout.span" [gridClass]="layout.class"></app-block-grid>
    </div>
</ng-container>